
export const addLightboxStyles = () => {
    if (!document.getElementById("lightbox-styles")) {
      const style = document.createElement("style");
      style.id = "lightbox-styles";
      style.innerHTML = `
        .lightbox-modal {
          display: none;
          position: fixed;
          z-index: 9999;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.9);
          overflow: auto;
          animation: fadeIn 0.3s;
        }
        
        .lightbox-modal-content {
          position: relative;
          margin: auto;
          max-width: 1200px;
          width: 90%;
          height: 90vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        
        .lightbox-image-container {
          position: relative;
          flex-grow: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .lightbox-image {
          max-height: 75vh;
          max-width: 100%;
          object-fit: contain;
          transition: transform 0.3s;
        }
        
        .lightbox-close {
          position: absolute;
          top: 20px;
          right: 20px;
          color: white;
          font-size: 35px;
          font-weight: bold;
          cursor: pointer;
          z-index: 10;
          transition: color 0.3s;
        }
        
        .lightbox-prev,
        .lightbox-next {
          cursor: pointer;
          position: absolute;
          top: 50%;
          width: auto;
          padding: 16px;
          margin-top: -22px;
          color: white;
          font-weight: bold;
          font-size: 24px;
          transition: 0.3s;
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 50%;
        }
        
        .lightbox-next { right: 20px; }
        .lightbox-prev { left: 20px; }
        
        .lightbox-counter {
          color: white;
          text-align: center;
          padding: 10px 0;
        }
        
        .lightbox-thumbnails {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 10px;
          padding: 10px 0;
          max-height: 100px;
          overflow-y: auto;
        }
        
        .lightbox-thumbnail {
          width: 60px;
          height: 60px;
          object-fit: cover;
          cursor: pointer;
          opacity: 0.7;
          transition: all 0.3s;
          border: 2px solid transparent;
        }
        
        .lightbox-thumbnail:hover,
        .lightbox-thumbnail.active {
          opacity: 1;
          border-color: #4CAF50;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }
  };

  export const addBiocharStyles = () => {
    if (!document.getElementById("biochar-viewer-styles")) {
      const style = document.createElement("style");
      style.id = "biochar-viewer-styles";
      style.innerHTML = `
        
        /* Tab system styles */
        .biochar-tabs {
          display: flex;
          border-bottom: 1px solid #ccc;
          margin-bottom: 12px;
          overflow-x: auto;
        }
        .biochar-tab {
          background-color: #f1f1f1;
          border: none;
          outline: none;
          cursor: pointer;
          padding: 8px 12px;
          font-size: 14px;
          transition: 0.3s;
          border-radius: 4px 4px 0 0;
          margin-right: 2px;
          white-space: nowrap;
        }
        .biochar-tab:hover {
          background-color: #ddd;
        }
        .biochar-tab.active {
          background-color: #4caf50;
          color: white;
        }
        .biochar-tab-content {
          display: none;
          padding: 6px 12px;
          border: 1px solid #ccc;
          border-top: none;
          animation: fadeIn 0.5s;
          border-radius: 0 0 4px 4px;
          margin-bottom: 10px;
        }
        @keyframes fadeIn {
          from {opacity: 0;}
          to {opacity: 1;}
        }
        
        /* Gallery styles */
        .biochar-gallery {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
          width: 100%;
          margin-bottom: 10px;
        }
        .biochar-gallery-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }
        .biochar-gallery-item img {
          width: 100%;
          height: 100px;
          object-fit: cover;
          cursor: pointer;
          transition: opacity 0.3s;
          border-radius: 4px;
        }
        .biochar-gallery-item img:hover {
          opacity: 0.8;
        }
        .biochar-gallery-item p {
          margin: 5px 0 0 0;
          font-size: 12px;
          text-align: center;
          color: #333;
        }
        
        /* Loader styles */
        .biochar-loader-container {
          position: relative;
          width: 100%;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f5f5f5;
          border-radius: 4px;
        }
        .biochar-loader {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #4CAF50;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* Fields table styles */
        .biochar-fields-table {
          width: 100%;
          border-collapse: collapse;
        }
        .biochar-fields-table td {
          padding: 6px;
          border-bottom: 1px solid #eee;
        }
        .biochar-fields-table tr:last-child td {
          border-bottom: none;
        }
        .biochar-fields-table tr:nth-child(even) {
          background-color: #f9f9f9;
        }
        .biochar-fields-table tr:hover {
          background-color: #f0f0f0;
        }
        .biochar-field-label {
          font-weight: bold;
          color: #555;
          width: 40%;
        }
        
        /* Error styles */
        .biochar-error {
          background-color: #ffe6e6;
          padding: 8px;
          border-radius: 4px;
          margin: 10px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .biochar-error-close {
          cursor: pointer;
          font-weight: bold;
          margin-left: 10px;
        }
        
      .biochar-action-button {
      margin-top: 10px;
      padding: 8px 12px;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.3s ease, opacity 0.3s ease;
    }

    .biochar-action-button:hover {
      opacity: 0.9;
    }

    .biochar-action-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    /* Style for the active tab */
    .biochar-tab.active {
      font-weight: bold;
      border-bottom: 2px solid #4CAF50;
    }
    
        
        /* Responsive adjustments */
        @media (max-width: 600px) {
          .biochar-gallery {
            grid-template-columns: 1fr;
          }
          .biochar-tabs {
            flex-wrap: wrap;
          }
          .biochar-tab {
            flex: 1 1 auto;
            min-width: 80px;
            font-size: 12px;
            padding: 6px 8px;
          }
          .biochar-lightbox-content {
            max-height: 80vh;
            max-width: 95vw;
          }
          .biochar-fields-table td {
            font-size: 12px;
            padding: 4px;
          }
        }
        @media (max-width: 400px) {
          .biochar-gallery-item img {
            height: 80px;
          }
        }
      `;
      document.head.appendChild(style);
    }
  };

export const addFactoryStyles = () => {
    if (!document.getElementById("factory-viewer-styles")) {
      const style = document.createElement("style");
      style.id = "factory-viewer-styles";
      style.innerHTML = `    
        /* Tab system styles */
        .factory-tabs {
          display: flex;
          border-bottom: 1px solid #ccc;
          margin-bottom: 12px;
          overflow-x: auto;
        }
        .factory-tab {
          background-color: #f1f1f1;
          border: none;
          outline: none;
          cursor: pointer;
          padding: 8px 12px;
          font-size: 14px;
          transition: 0.3s;
          border-radius: 4px 4px 0 0;
          margin-right: 2px;
          white-space: nowrap;
        }
        .factory-tab:hover {
          background-color: #ddd;
        }
        .factory-tab.active {
          background-color: #4caf50;
          color: white;
        }
        .factory-tab-content {
          display: none;
          padding: 6px 12px;
          border: 1px solid #ccc;
          border-top: none;
          animation: fadeIn 0.5s;
          border-radius: 0 0 4px 4px;
          margin-bottom: 10px;
        }
        @keyframes fadeIn {
          from {opacity: 0;}
          to {opacity: 1;}
        }
        
        /* Gallery styles */
        .factory-gallery {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
          width: 100%;
          margin-bottom: 10px;
        }
        .factory-gallery-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }
        .factory-gallery-item img {
          width: 100%;
          height: 100px;
          object-fit: cover;
          cursor: pointer;
          transition: opacity 0.3s;
          border-radius: 4px;
        }
        .factory-gallery-item img:hover {
          opacity: 0.8;
        }
        .factory-gallery-item p {
          margin: 5px 0 0 0;
          font-size: 12px;
          text-align: center;
          color: #333;
        }
        
        /* Loader styles */
        .factory-loader-container {
          position: relative;
          width: 100%;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f5f5f5;
          border-radius: 4px;
        }
        .factory-loader {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #3498db;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* Fields table styles */
        .factory-fields-table {
          width: 100%;
          border-collapse: collapse;
        }
        .factory-fields-table td {
          padding: 6px;
          border-bottom: 1px solid #eee;
        }
        .factory-fields-table tr:last-child td {
          border-bottom: none;
        }
        .,factory-fields-table tr:nth-child(even) {
          background-color: #f9f9f9;
        }
        .factory-fields-table tr:hover {
          background-color: #f0f0f0;
        }
        .factory-field-label {
          font-weight: bold;
          color: #555;
          width: 40%;
        }
        
        /* Error styles */
        .factory-error {
          background-color: #ffe6e6;
          padding: 8px;
          border-radius: 4px;
          margin: 10px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .factory-error-close {
          cursor: pointer;
          font-weight: bold;
          margin-left: 10px;
        }
        
        /* Responsive adjustments */
        @media (max-width: 600px) {
          .factory-gallery {
            grid-template-columns: 1fr;
          }
          .factory-tabs {
            flex-wrap: wrap;
          }
          .factory-tab {
            flex: 1 1 auto;
            min-width: 80px;
            font-size: 12px;
            padding: 6px 8px;
          }
          .factory-lightbox-content {
            max-height: 80vh;
            max-width: 95vw;
          }
          .factory-fields-table td {
            font-size: 12px;
            padding: 4px;
          }
        }
        @media (max-width: 400px) {
          .factory-gallery-item img {
            height: 80px;
          }
        }
      `;
      document.head.appendChild(style);
    }
  };